import mePhoto from "../../img/me.webp";
import { WINDOW_IDS } from "../../data/windows";
import { Window } from "../Window/Window";
import classes from "./Picture.module.css";

export const Picture = () => (
  <Window id={WINDOW_IDS.IMAGE} classes={classes}>
    <div className={classes.pixelate}>
      <img
        src={mePhoto}
        alt="me chilling"
        className={classes.photo}
        draggable={false}
      />
    </div>
  </Window>
);
